// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  flex: 1 1 auto;
  padding: 24px;
  background-color: #1a1a1a;
  color: #ffffff;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  /* Scroll único en .layout-content — evita recortar secciones inferiores en móvil */
  overflow: visible;
}

.dashboard-container--xtam {
  padding: 20px 24px 48px;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  min-width: 0;
}

.dashboard-xtam-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.dashboard-xtam-title {
  margin: 0;
  font-size: clamp(1.1rem, 2.5vw, 1.35rem);
  font-weight: 700;
  color: #f3f4f6;
}

.dashboard-xtam-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.dashboard-xtam-refresh {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #374151;
  background: #111;
  color: #e5e7eb;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.dashboard-xtam-refresh:hover:not(:disabled) {
  border-color: #4b5563;
  background: #1a1a1a;
}

.dashboard-xtam-refresh:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.dashboard-xtam-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  overscroll-behavior-x: contain;
  overscroll-behavior-y: auto;
  touch-action: pan-x pan-y;
}

.dashboard-xtam-row__item {
  scroll-snap-align: start;
  flex: 0 0 auto;
  max-width: 100%;
}

@media (max-width: 768px) {
  .dashboard-container--xtam {
    padding: 16px 16px 56px;
  }

  .dashboard-xtam-row {
    flex-direction: column;
    flex-wrap: nowrap;
    overflow: visible;
    touch-action: auto;
    scroll-snap-type: none;
    padding-bottom: 0;
  }

  .dashboard-xtam-row__item {
    width: 100%;
  }

  .dashboard-xtam-row__item .xtd-city-card {
    width: 100%;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPage.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mFAAmF;EACnF,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".dashboard-container {\n  flex: 1 1 auto;\n  padding: 24px;\n  background-color: #1a1a1a;\n  color: #ffffff;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  /* Scroll único en .layout-content — evita recortar secciones inferiores en móvil */\n  overflow: visible;\n}\n\n.dashboard-container--xtam {\n  padding: 20px 24px 48px;\n}\n\n.dashboard-content {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.dashboard-xtam-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.dashboard-xtam-title {\n  margin: 0;\n  font-size: clamp(1.1rem, 2.5vw, 1.35rem);\n  font-weight: 700;\n  color: #f3f4f6;\n}\n\n.dashboard-xtam-subtitle {\n  margin: 6px 0 0;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.dashboard-xtam-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background: #111;\n  color: #e5e7eb;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dashboard-xtam-refresh:hover:not(:disabled) {\n  border-color: #4b5563;\n  background: #1a1a1a;\n}\n\n.dashboard-xtam-refresh:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.dashboard-xtam-row {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 16px;\n  overflow-x: auto;\n  overflow-y: visible;\n  padding-bottom: 4px;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n  overscroll-behavior-x: contain;\n  overscroll-behavior-y: auto;\n  touch-action: pan-x pan-y;\n}\n\n.dashboard-xtam-row__item {\n  scroll-snap-align: start;\n  flex: 0 0 auto;\n  max-width: 100%;\n}\n\n@media (max-width: 768px) {\n  .dashboard-container--xtam {\n    padding: 16px 16px 56px;\n  }\n\n  .dashboard-xtam-row {\n    flex-direction: column;\n    flex-wrap: nowrap;\n    overflow: visible;\n    touch-action: auto;\n    scroll-snap-type: none;\n    padding-bottom: 0;\n  }\n\n  .dashboard-xtam-row__item {\n    width: 100%;\n  }\n\n  .dashboard-xtam-row__item .xtd-city-card {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
